// Auto-generates item numbers: 8109-1, 8109-2, etc.
// Each window line gets its own item number sequentially

export function generateItemNumbers(woNumber, windows) {
  let counter = 1;
  return windows.map(w => ({
    ...w,
    itemNumber: `${woNumber}-${counter++}`,
  }));
}